import { render } from "./Shopkeeper.vue?vue&type=template&id=3a0d7d59"
import script from "./Shopkeeper.vue?vue&type=script&lang=js"
export * from "./Shopkeeper.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__